import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlSignature } from '../common/apiEndpoint';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PreviousEnrollment } from './previousEnrollment';

@Injectable()
export class PreUniversityService {
  constructor(
    private httpClient: HttpClient,
    private urlSignature: UrlSignature,
  ) {}

  getPreviousEnrolment(personId: string): Observable<PreviousEnrollment> {
    const url = this.urlSignature.previousEnrollmentByIdUrl + personId;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as PreviousEnrollment));
  }
}
